import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Axios from "axios";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./ReceptBillSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const WASTE = "Wastage";

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const objects = {
  ORDER: "Order",
  REFUND: "Refund",
};

class ReceipBillsImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    noFile: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          noFile: false,
        });
      })
      .catch((res) => {
        this.setState({
          loading: false,
          noFile: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="' +
        Configs.abossUrl +
        '/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  calculateRoundValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return Filter.displayCurrency(partOne);
  };

  setPaymentTypeTable = (
    results,
    saleType,
    type,
    title,
    rowsPayment,
    period,
    summaryTitle
  ) => {
    const rowsPaymentSort = [...rowsPayment, ...summaryTitle].sort();
    let values = [];

    const rowsPaymentSort2 = rowsPaymentSort.filter(function (
      value,
      index,
      array
    ) {
      return array.indexOf(value) == index;
    });

    const rowsPaymentSort2Length = rowsPaymentSort2.length;
    for (var m = 0; m < rowsPaymentSort2Length; m++) {
      if (
        results[
          "Period_" +
            period +
            "_" +
            rowsPaymentSort2[m] +
            "_" +
            saleType +
            "_M" +
            "_" +
            type +
            "_" +
            objects.ORDER
        ] != undefined
      ) {
        if (
          results[
            "Period_" +
              period +
              "_" +
              rowsPaymentSort2[m] +
              "_" +
              saleType +
              "_M" +
              "_" +
              type +
              "_" +
              objects.ORDER
          ] != 0 &&
          rowsPaymentSort2[m] != ""
        ) {
          const value =
            Math.round(
              results[
                "Period_" +
                  period +
                  "_" +
                  rowsPaymentSort2[m] +
                  "_" +
                  saleType +
                  "_M" +
                  "_" +
                  type +
                  "_" +
                  objects.ORDER
              ] * 100
            ) / 100;

          values.push({
            name: rowsPaymentSort2[m],
            val: Filter.displayCurrency(value),
          });
        }
      }
    }
    var showTotal = 0;
    if (
      results[
        "Period_" +
          period +
          "_" +
          "PaymentType_Total_" +
          saleType +
          "_M" +
          "_" +
          type +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      showTotal =
        Math.round(
          results[
            "Period_" +
              period +
              "_" +
              "PaymentType_Total_" +
              saleType +
              "_M" +
              "_" +
              type +
              "_" +
              objects.ORDER
          ] * 100
        ) / 100;
    }

    if (showTotal == 0) {
      return (
        <Table2 title={title}>
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: Filter.displayCurrency(showTotal),
    });

    return (
      <Table2 title={title}>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={[value.val]}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={[value.val]}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setPaymentTypeRefundTable = (
    results,
    saleType,
    type,
    title,
    rowsPayment,
    period,
    summaryTitle
  ) => {
    const rowsPaymentSort = [...rowsPayment, ...summaryTitle].sort();
    let values = [];

    const rowsPaymentSort2 = rowsPaymentSort.filter(function (
      value,
      index,
      array
    ) {
      return array.indexOf(value) == index;
    });

    const rowsPaymentSort2Length = rowsPaymentSort2.length;
    for (var m = 0; m < rowsPaymentSort2Length; m++) {
      if (
        results[
          "Period_" +
            period +
            "_" +
            rowsPaymentSort2[m] +
            "_" +
            saleType +
            "_M" +
            "_" +
            type +
            "_" +
            objects.REFUND
        ] != undefined
      ) {
        if (
          results[
            "Period_" +
              period +
              "_" +
              rowsPaymentSort2[m] +
              "_" +
              saleType +
              "_M" +
              "_" +
              type +
              "_" +
              objects.REFUND
          ] != 0 &&
          rowsPaymentSort2[m] != ""
        ) {
          const value =
            Math.round(
              results[
                "Period_" +
                  period +
                  "_" +
                  rowsPaymentSort2[m] +
                  "_" +
                  saleType +
                  "_M" +
                  "_" +
                  type +
                  "_" +
                  objects.REFUND
              ] * 100
            ) / 100;

          values.push({
            name: rowsPaymentSort2[m],
            val: Filter.displayCurrency(value),
          });
        }
      }
    }
    var showTotal = 0;
    if (
      results[
        "Period_" +
          period +
          "_" +
          "PaymentType_Total_" +
          saleType +
          "_M" +
          "_" +
          type +
          "_" +
          objects.REFUND
      ] != undefined
    ) {
      showTotal =
        Math.round(
          results[
            "Period_" +
              period +
              "_" +
              "PaymentType_Total_" +
              saleType +
              "_M" +
              "_" +
              type +
              "_" +
              objects.REFUND
          ] * 100
        ) / 100;
    }

    if (showTotal == 0) {
      return (
        <Table2 title={title}>
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: Filter.displayCurrency(showTotal),
    });

    return (
      <Table2 title={title}>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={[value.val]}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={[value.val]}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setDiscountTable = (
    results,
    saleType,
    title,
    rowsPayment,
    period,
    discounts
  ) => {
    let values = [];
    const discountsLength = discounts.length;
    for (var m = 0; m < discountsLength; m++) {
      for (var d = 1; d <= 100; d++) {
        if (
          results[
            "Period_" +
              period +
              "_" +
              rowsPayment[16] +
              "_" +
              saleType +
              "_" +
              d +
              "_" +
              discounts[m] +
              "_" +
              objects.ORDER
          ] != undefined
        ) {
          const value =
            Math.round(
              results[
                "Period_" +
                  period +
                  "_" +
                  rowsPayment[16] +
                  "_" +
                  saleType +
                  "_" +
                  d +
                  "_" +
                  discounts[m] +
                  "_" +
                  objects.ORDER
              ] * 100
            ) / 100;
          values.push({
            name: d.toString() + " (" + discounts[m] + ")",
            val: [Filter.displayCurrency(value)],
          });
        }
      }
    }
    var showTotal = 0;
    if (
      results[
        "Total_" +
          "Period_" +
          period +
          "_" +
          rowsPayment[16] +
          "_" +
          saleType +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      showTotal =
        results[
          "Total_" +
            "Period_" +
            period +
            "_" +
            rowsPayment[16] +
            "_" +
            saleType +
            "_" +
            objects.ORDER
        ];
    }

    if (showTotal == 0) {
      return (
        <Table2 title={title}>
          <tr>
            <td colSpan="2">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }
    values.push({
      name: "Total",
      val: [Filter.displayCurrency(showTotal)],
    });
    return (
      <Table2 title={title}>
        <Row
          styleRow={styleRowTotal}
          name={"Percentage(%)"}
          values={[""]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setCashierTable(results, saleType, cashiers, title, rowsPayment, period) {
    let values = [];
    const cashiersLength = cashiers.length;
    for (let i = 0; i < cashiersLength; i++) {
      if (
        results[
          "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            cashiers[i] +
            "_" +
            rowsPayment[24] +
            "_" +
            objects.ORDER
        ] != undefined &&
        results[
          "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            cashiers[i] +
            "_" +
            rowsPayment[27] +
            "_" +
            objects.ORDER
        ] != undefined
      ) {
        const valueGross =
          Math.round(
            results[
              "Period_" +
                period +
                "_" +
                rowsPayment[9] +
                "_" +
                saleType +
                "_" +
                cashiers[i] +
                "_" +
                rowsPayment[24] +
                "_" +
                objects.ORDER
            ] * 100
          ) / 100;
        const valueReceived =
          Math.round(
            results[
              "Period_" +
                period +
                "_" +
                rowsPayment[9] +
                "_" +
                saleType +
                "_" +
                cashiers[i] +
                "_" +
                rowsPayment[27] +
                "_" +
                objects.ORDER
            ] * 100
          ) / 100;

        values.push({
          name: cashiers[i],
          val: [
            Filter.displayCurrency(valueGross),
            Filter.displayCurrency(valueReceived),
          ],
        });
      }
    }

    let totalGrossValue = 0,
      totalReceverValue = 0;

    if (
      results[
        "Total_" +
          "Period_" +
          period +
          "_" +
          rowsPayment[9] +
          "_" +
          saleType +
          "_" +
          rowsPayment[24] +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      totalGrossValue =
        results[
          "Total_" +
            "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            rowsPayment[24] +
            "_" +
            objects.ORDER
        ];
    }
    if (
      results[
        "Total_" +
          "Period_" +
          period +
          "_" +
          rowsPayment[9] +
          "_" +
          saleType +
          "_" +
          rowsPayment[27] +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      totalReceverValue =
        results[
          "Total_" +
            "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            rowsPayment[27] +
            "_" +
            objects.ORDER
        ];
    }

    if (totalGrossValue == 0 || totalReceverValue == 0) {
      return (
        <Table2 title={title}>
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    values.push({
      name: "Total",
      val: [
        Filter.displayCurrency(totalGrossValue),
        Filter.displayCurrency(totalReceverValue),
      ],
    });

    return (
      <Table2 title={title}>
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Gross", "Received"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  }

  setAgentTable(results, saleType, cashiers, title, rowsPayment, period) {
    let values = [];
    const cashiersLength = cashiers.length;
    for (let i = 0; i < cashiersLength; i++) {
      if (
        results[
          "Period_" +
            period +
            "_" +
            rowsPayment[10] +
            "_" +
            saleType +
            "_" +
            cashiers[i] +
            "_" +
            rowsPayment[24] +
            "_" +
            objects.ORDER
        ] != undefined &&
        results[
          "Period_" +
            period +
            "_" +
            rowsPayment[10] +
            "_" +
            saleType +
            "_" +
            cashiers[i] +
            "_" +
            rowsPayment[27] +
            "_" +
            objects.ORDER
        ] != undefined
      ) {
        const valueGross =
          Math.round(
            results[
              "Period_" +
                period +
                "_" +
                rowsPayment[10] +
                "_" +
                saleType +
                "_" +
                cashiers[i] +
                "_" +
                rowsPayment[24] +
                "_" +
                objects.ORDER
            ] * 100
          ) / 100;
        const valueReceived =
          Math.round(
            results[
              "Period_" +
                period +
                "_" +
                rowsPayment[10] +
                "_" +
                saleType +
                "_" +
                cashiers[i] +
                "_" +
                rowsPayment[27] +
                "_" +
                objects.ORDER
            ] * 100
          ) / 100;

        values.push({
          name: cashiers[i],
          val: [
            Filter.displayCurrency(valueGross),
            Filter.displayCurrency(valueReceived),
          ],
        });
      }
    }

    let totalGrossValue = 0,
      totalReceverValue = 0;

    if (
      results[
        "Total_" +
          "Period_" +
          period +
          "_" +
          rowsPayment[10] +
          "_" +
          saleType +
          "_" +
          rowsPayment[24] +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      totalGrossValue =
        results[
          "Total_" +
            "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            rowsPayment[24] +
            "_" +
            objects.ORDER
        ];
    }
    if (
      results[
        "Total_" +
          "Period_" +
          period +
          "_" +
          rowsPayment[10] +
          "_" +
          saleType +
          "_" +
          rowsPayment[27] +
          "_" +
          objects.ORDER
      ] != undefined
    ) {
      totalReceverValue =
        results[
          "Total_" +
            "Period_" +
            period +
            "_" +
            rowsPayment[9] +
            "_" +
            saleType +
            "_" +
            rowsPayment[27] +
            "_" +
            objects.ORDER
        ];
    }

    if (totalGrossValue == 0 || totalReceverValue == 0) {
      return (
        <Table2 title={title}>
          <tr>
            <td colSpan="3">
              <b>No Data Available</b>
            </td>
          </tr>
        </Table2>
      );
    }

    values.push({
      name: "Total",
      val: [
        Filter.displayCurrency(totalGrossValue),
        Filter.displayCurrency(totalReceverValue),
      ],
    });

    return (
      <Table2 title={title}>
        <Row
          styleRow={styleRowTotal}
          name={""}
          values={["Gross", "Received"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  }

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.noFile) {
      return <NoData></NoData>;
    }

    const ownerId = this.props.ownerId;

    const rowsPayment = [
      "Sale Type",
      "Date Time",
      "Order No",
      "Status",
      "Table",
      "Pax",
      "Total Dish(es)",
      "Cancel Dish(es)",
      "Waiter",
      "Cashier",
      "Agent",
      "Paid On",
      "Sales",
      Filter.changeToNameSettingsByOwner(
        "taxBeforeDiscount",
        "Tax Before Discount (%)",
        true,
        ownerId
      ),
      Filter.changeToNameSettingsByOwner(
        "taxBeforeDiscount",
        "Tax Before Discount",
        false,
        ownerId
      ),
      "Discount(%)",
      "Discount",
      "Sub Total",
      "Net Sales",
      Filter.changeToNameSettingsByOwner(
        "netTaxBeforeDiscount",
        "Net Tax Before Discount",
        false,
        ownerId
      ),
      Filter.changeToNameSettingsByOwner("tax1", "Tax 1 (%)", true, ownerId),
      Filter.changeToNameSettingsByOwner("tax1", "Tax 1", false, ownerId),
      Filter.changeToNameSettingsByOwner("tax2", "Tax 2 (%)", true, ownerId),
      Filter.changeToNameSettingsByOwner("tax2", "Tax 2", false, ownerId),
      "Gross",
      "Received-v1",
      "Note-v1",
      "Received",
      "Note",
      "Paid Type",
      "Split No.",
      "Gross (Exclude  Tax)",
      "Received-v1 (Exclude  Tax)",
      "Received (Exclude  Tax)",
      "Table/Bill",
      "Short Pay(-) -v1",
      "Over Pay(+) -v1",
      "Short Pay(-)",
      "Over Pay(+)",
      "Cash",
      "Pineapple",
      "stripe",
      "paypal",
    ];

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis };

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames };
      const controllers = [...analysis.controllers];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }
      const payTypes = [...analysis.paidType];
      const totalSummary = { ...analysis.totalSummary };
      const summaryDiscount = { ...analysis.summaryDiscount };
      const summaryCashierAndAgent = { ...analysis.summaryCashierAndAgent };
      const summaryTitle = [...analysis.summaryTitle];
      const discounts = [...analysis.discounts];
      const cashierAndAgent = [...analysis.cashierAndAgent];

      content = null;
      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;
        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;

        const contentChild = payTypes.map((payType, key) => {
          const totalPaxOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[5] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const totalDirectPaymentOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                "PaymentType_Total_" +
                payType +
                "_M_0" +
                "_" +
                objects.ORDER
            ] || 0;
          const totalTableOrBillOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[34] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const netSalesOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[18] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const netServiceChargeOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[19] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const netTotalOrder = netSalesOrder + netServiceChargeOrder;
          const tax1Order =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[21] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const tax2Order =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[23] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const grossOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[24] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const overPayOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[38] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const shortPayOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[37] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const subTotalOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[27] +
                "_" +
                payType +
                "_" +
                objects.ORDER
            ] || 0;
          const indirectPaymentOrder =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                "PaymentType_Total_" +
                payType +
                "_M_1" +
                "_" +
                objects.ORDER
            ] || 0;
          const paxSpeedOrder = +totalDirectPaymentOrder / +totalPaxOrder;
          const tableBillSpeedOrder =
            +totalDirectPaymentOrder / +totalTableOrBillOrder;

          //DailyRefundOrder
          const totalTableOrBillRefund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[34] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const netSalesRefund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[18] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const netServiceChargeRefund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[19] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const netTotalRefund = netSalesRefund + netServiceChargeRefund;
          const tax1Refund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[21] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const tax2Refund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[23] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const grossRefund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[24] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;
          const subTotalRefund =
            totalSummary[
              "Period_" +
                period.name +
                "_" +
                rowsPayment[27] +
                "_" +
                payType +
                "_" +
                objects.REFUND
            ] || 0;

          const col1 = (
            <React.Fragment>
              <Table title={`Sale ${payType}`}>
                <Row
                  styleRow={styleRow}
                  name={"No. of Table/Bill"}
                  values={[
                    this.calculateRoundValue(totalTableOrBillOrder, 2, false),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"No. of Pax"}
                  values={[this.calculateRoundValue(totalPaxOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Est. Net Sales"}
                  values={[this.calculateRoundValue(netSalesOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "netTaxBeforeDiscount",
                    "Net Tax Before Discount",
                    false,
                    ownerId
                  )}
                  values={[
                    this.calculateRoundValue(netServiceChargeOrder, 2, false),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Net Total"}
                  values={[
                    this.calculateRoundValue(netTotalOrder, 2, false, ownerId),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "tax1",
                    "Tax 1",
                    false,
                    ownerId
                  )}
                  values={[this.calculateRoundValue(tax1Order, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "tax2",
                    "Tax 2",
                    false,
                    ownerId
                  )}
                  values={[this.calculateRoundValue(tax2Order, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Gross"}
                  values={[this.calculateRoundValue(grossOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Over Pay(+)"}
                  values={[this.calculateRoundValue(overPayOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Short Pay(-)"}
                  values={[this.calculateRoundValue(shortPayOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Total Payment"}
                  values={[this.calculateRoundValue(subTotalOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Indirect Payment"}
                  values={[
                    this.calculateRoundValue(
                      -1 * indirectPaymentOrder,
                      2,
                      false
                    ),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRowTotal}
                  name={"Direct Payment"}
                  values={[
                    this.calculateRoundValue(totalDirectPaymentOrder, 2, false),
                  ]}
                ></Row>
                <Row styleRow={styleRow} name={<br></br>} values={[" "]}></Row>
                <Row styleRow={styleRow} name={" "} values={[" "]}></Row>
                <Row
                  styleRow={styleRow}
                  name={"Per Pax Spend"}
                  values={[this.calculateRoundValue(paxSpeedOrder, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Per Table/Bill Spend"}
                  values={[
                    this.calculateRoundValue(tableBillSpeedOrder, 2, false),
                  ]}
                ></Row>
                <Row styleRow={styleRow} name={<br></br>} values={[" "]}></Row>
                <Row styleRow={styleRow} name={<br></br>} values={[" "]}></Row>
              </Table>
              <Table title={`Refund`}>
                <Row styleRow={styleRow} name={"Refund"} values={[" "]}></Row>
                <Row
                  styleRow={styleRow}
                  name={"No. of Table/Bill"}
                  values={[
                    this.calculateRoundValue(totalTableOrBillRefund, 2, false),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Est. Net Sales"}
                  values={[this.calculateRoundValue(netSalesRefund, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "netTaxBeforeDiscount",
                    "Net Tax Before Discount",
                    false,
                    ownerId
                  )}
                  values={[
                    this.calculateRoundValue(netServiceChargeRefund, 2, false),
                  ]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Net Total"}
                  values={[this.calculateRoundValue(netTotalRefund, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "tax1",
                    "Tax 1",
                    false,
                    ownerId
                  )}
                  values={[this.calculateRoundValue(tax1Refund, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={Filter.changeToNameSettingsByOwner(
                    "tax2",
                    "Tax 2",
                    false,
                    ownerId
                  )}
                  values={[this.calculateRoundValue(tax2Refund, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRow}
                  name={"Gross"}
                  values={[this.calculateRoundValue(grossRefund, 2, false)]}
                ></Row>
                <Row
                  styleRow={styleRowTotal}
                  name={"Total"}
                  values={[this.calculateRoundValue(subTotalRefund, 2, false)]}
                ></Row>
              </Table>
            </React.Fragment>
          );

          const col2 = (
            <div>
              {this.setPaymentTypeTable(
                totalSummary,
                payType,
                0,
                "DIRECT PAYMENT TYPE",
                rowsPayment,
                period.name,
                summaryTitle
              )}
              {this.setPaymentTypeTable(
                totalSummary,
                payType,
                1,
                "INDIRECT PAYMENT TYPE",
                rowsPayment,
                period.name,
                summaryTitle
              )}
              {this.setPaymentTypeRefundTable(
                totalSummary,
                payType,
                0,
                "REFUND DIRECT PAYMENT TYPE",
                rowsPayment,
                period.name,
                summaryTitle
              )}
              {this.setPaymentTypeRefundTable(
                totalSummary,
                payType,
                1,
                "REFUND INDIRECT PAYMENT TYPE",
                rowsPayment,
                period.name,
                summaryTitle
              )}
              {this.setDiscountTable(
                summaryDiscount,
                payType,
                "BILL DISCOUNT",
                rowsPayment,
                period.name,
                discounts
              )}
              {this.setCashierTable(
                summaryCashierAndAgent,
                payType,
                cashierAndAgent,
                "CASHIER",
                rowsPayment,
                period.name
              )}
              {this.setAgentTable(
                summaryCashierAndAgent,
                payType,
                cashierAndAgent,
                "AGENT",
                rowsPayment,
                period.name
              )}
            </div>
          );

          return (
            <table
              key={key}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr className="desktop hidden-xs hidden-sm">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "30%",
                    }}
                  >
                    {col1}
                  </Column>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "70%",
                    }}
                  >
                    {col2}
                  </Column>
                </tr>
                <tr className="mobile hidden-md hidden-lg">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {col1}
                  </Column>
                </tr>
                <tr className="mobile hidden-md hidden-lg">
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {col2}
                  </Column>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                {key + 1 !== payTypes.length ? (
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          );
        });

        return (
          <Content
            key={key}
            title="SALE SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            {contentChild}
          </Content>
        );
      });
    }

    return (
      <div className="ReceptBillSummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReceipBillsImportSummary;
